export const BASE_URL = "https://"+window.location.host;
export const API_URL = "https://"+window.location.host + '/ecrweb/index.php?r=';
export const userTokenStorageKey = 'jwt-token';
export const ORG_ID = window.location.hostname === 'localhost' ? 'hs' : window.location.host.split(".")[0]
export const SCRIPT_URL= window.location.hostname === 'localhost'?process.env.VUE_APP_PROXY_URL+"/ecrweb":window.location.host
